/* eslint-disable no-param-reassign */
import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'
import TestAPI from '@/api/test'


function getEmptyTestState() {
  return {
    test: null,
    isTestCreationMode: false,
    isTestViewMode: false,
    editedTestId: null,
    backLink: '',
    isTestingMode: false,
    progress: null,
    solvedTasks: []
  }
}

export default {
  state: {
    ...getEmptyTestState()
  },
  mutations: {
    [MUTATION_TYPE.clearTestContent]: (state) => {
      Object.assign(state, getEmptyTestState())
    },
    [MUTATION_TYPE.setTestCreationMode]: (state, testCreation) => {
      state.isTestCreationMode = testCreation
    },
    [MUTATION_TYPE.setTestingMode]: (state, testingMode) => {
      state.isTestingMode = testingMode
    },
    [MUTATION_TYPE.setEditedTestId]: (state, testId) => {
      state.editedTestId = testId
    },
    [MUTATION_TYPE.setTestViewMode]: (state, testView) => {
      state.isTestViewMode = testView
    },
    [MUTATION_TYPE.setBackLink]: (state, link) => {
      state.backLink = link
    },
    [MUTATION_TYPE.setTest]: (state, test) => {
      state.test = test
    },
    [MUTATION_TYPE.setProgress]: (state, progress) => {
      state.progress = progress
    },
    [MUTATION_TYPE.updateSolvedTasks]: (state, tasks) => {
      state.solvedTasks = tasks
    },
    [MUTATION_TYPE.setTestInTestModulePositions]: (state) => {
      TestAPI.shuffle(state.test.subSections)
      state.test.subSections.forEach((subSection, index) => {
        subSection.position = index
      })
    }
  },
  actions: {
    [ACTION_TYPE.fetchTest]: async ({ commit }, { courseId, testId }) => {
      const test = await TestAPI.getTest(courseId, testId)
      commit('setTest', test.data)
      // test.data.courseContent - ?
      if (test.data && test.data.subSections) {
        commit('education/addTestSubSectionsToCourse', test.data, { root: true })
        commit('setTestInTestModulePositions')
        commit('education/prepareCourseTestPositions', null, { root: true })
        commit('education/setSubSectionHashes', null, { root: true })
      }
    },
    [ACTION_TYPE.sendTestAnswer]: async ({ state, commit }, { testId, taskId, answer }) => {
      const { task } = state.test.subSections.filter((ss) => ss.id === Number(taskId))[0]
      const test = await TestAPI.sendTestAnswer(testId, task.id, answer)
      commit('setProgress', test.data.progress)
    },
    [ACTION_TYPE.updateTestCreationMode]: ({ commit }, testCreation) => {
      commit('setTestCreationMode', testCreation)
    },
    [ACTION_TYPE.updateEditedTest]: ({ commit }, testId) => {
      commit('setEditedTestId', testId)
    },
    [ACTION_TYPE.updateTestViewMode]: ({ commit }, testView) => {
      commit('setTestViewMode', testView)
    },
    [ACTION_TYPE.updateBackLink]: ({ commit }, link) => {
      commit('setBackLink', link)
    },
    [ACTION_TYPE.resetTestingModes]: ({ commit }) => {
      commit('setTestingMode', false)
      commit('setTestViewMode', false)
      commit('setTestCreationMode', false)
    }
  },
  getters: {
    [GETTER_TYPE.isTestCreationMode]: (state) => state.isTestCreationMode,
    [GETTER_TYPE.isTestViewMode]: (state) => state.isTestViewMode,
    [GETTER_TYPE.isTestingMode]: (state) => state.isTestingMode,
    [GETTER_TYPE.getEditedTestId]: (state) => state.editedTestId,
    [GETTER_TYPE.getBackLink]: (state) => state.backLink,
    [GETTER_TYPE.getTest]: (state) => state.test,
    [GETTER_TYPE.getProgress]: (state) => state.progress,
    [GETTER_TYPE.getSolvedTasks]: (state) => state.solvedTasks
  }
}
